import React from 'react';
import { Clock, Mail, Phone } from 'lucide-react';

const Footer = ({ countdown, isApplicationClosed }) => {
  return (
    <footer className="bg-gray-900 text-white mt-16">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center">
                <img src="/favicon.svg" alt="Techpuram Logo" className="w-8 h-8" />
              </div>
              <div>
                <h3 className="text-xl font-bold">Techpuram</h3>
                <p className="text-sm text-gray-400">Innovation & Technology</p>
              </div>
            </div>
            <p className="text-gray-300 mb-4">
              Empowering students with real-world experience through our comprehensive internship program.
            </p>
            <div className="space-y-2 text-sm text-gray-400">
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4" />
                <span>info@techpuram.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4" />
                <span>+91 9488236564</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-gray-300">
              <li>
                <a href="https://techpuram.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors">
                  Company Website
                </a>
              </li>
              
            </ul>
          </div>

          {/* Application Deadline */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Applications Open</h4>
            {!isApplicationClosed ? (
              <div className="bg-gray-800 border border-gray-700 rounded-xl p-4">
                <div className="flex items-center space-x-2 text-gray-300 mb-2">
                  <Clock className="w-5 h-5" />
                  <span className="font-semibold">Application Deadline</span>
                </div>
                <div className="text-lg font-bold text-white mb-2">
                  September 10th, 2025
                </div>

                {/* Live Countdown Timer */}
                <div className="grid grid-cols-4 gap-2 mb-3">
                  <div className="text-center">
                    <div className="text-lg font-bold text-white">{countdown.days}</div>
                    <div className="text-xs text-gray-400">Days</div>
                  </div>
                  <div className="text-center">
                    <div className="text-lg font-bold text-white">{countdown.hours}</div>
                    <div className="text-xs text-gray-400">Hours</div>
                  </div>
                  <div className="text-center">
                    <div className="text-lg font-bold text-white">{countdown.minutes}</div>
                    <div className="text-xs text-gray-400">Minutes</div>
                  </div>
                  <div className="text-center">
                    <div className="text-lg font-bold text-white">{countdown.seconds}</div>
                    <div className="text-xs text-gray-400">Seconds</div>
                  </div>
                </div>

                <div className="text-sm text-gray-400 text-center">
                  Last date to apply
                </div>
              </div>
            ) : (
              <div className="bg-gray-800 border border-gray-700 rounded-xl p-4 text-center">
                <div className="text-gray-400 mb-4">
                  <Clock className="w-8 h-8 mx-auto mb-2" />
                  <div className="font-semibold text-lg">Applications Closed</div>
                </div>
                <p className="text-sm text-gray-300 mb-4">
                  Thank you for your interest! This internship drive has ended.
                </p>
                <div className="space-y-3">
                  <p className="text-sm text-gray-400">
                    Stay updated on our next internship drive:
                  </p>
                  <div className="flex justify-center space-x-4">
                    <a 
                      href="https://linkedin.com/company/tech-puram" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-blue-400 hover:text-blue-300 transition-colors text-sm"
                    >
                      LinkedIn
                    </a>
                    <a 
                      href="https://twitter.com/tech_puram" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-blue-400 hover:text-blue-300 transition-colors text-sm"
                    >
                      Twitter
                    </a>
                    <a 
                      href="https://instagram.com/techpuram_technology/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-blue-400 hover:text-blue-300 transition-colors text-sm"
                    >
                      Instagram
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2025 Techpuram Technology Private Limited. All rights reserved.
            </div>
            <div className="flex space-x-6 text-sm text-gray-400">
              <a href="https://techpuram.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors">Techpuram</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
